export function ApiKeys() {
  return (
    <div className="api-keys">
      <div className="page-header">
        <h2>My API Keys</h2>
      </div>
      <p className="subtitle">
        Include your M&B Internal API key in the <code>X-Api-Key</code> header with every request. No additional auth is required.
      </p>

      <div className="keys-placeholder">
        <p>To obtain or manage API keys, please contact the <strong>APG IT team</strong>.</p>
      </div>

      <div className="getting-started">
        <h3>Getting Started</h3>
        <p>All requests require an API key via the X-Api-Key header.</p>
        <code className="code-block">
          {`curl -H "X-Api-Key: YOUR_KEY" \\
  https://api.meshandbar.com.au/v1/studio/getJobData?xxxxx`}
        </code>
      </div>

      <div className="usage-info">
        <h3>Usage Plans</h3>
        <div className="plans">
          <div className="plan">
            <h4>Standard</h4>
            <ul>
              <li>5,000 requests/day</li>
              <li>10 requests/second</li>
              <li>Burst: 20 requests</li>
            </ul>
          </div>
          <div className="plan">
            <h4>Studio QLD</h4>
            <ul>
              <li>50,000 requests/day</li>
              <li>10 requests/second</li>
              <li>Burst: 20 requests</li>
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        .api-keys h2 { margin-bottom: 0.5rem; }
        .page-header { margin-bottom: 0.5rem; }
        .subtitle { color: var(--color-text-muted); margin-bottom: 2rem; }
        .subtitle code { background: var(--color-bg); padding: 0.125rem 0.375rem; border-radius: 3px; font-size: 0.85em; }
        .keys-placeholder { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: 8px; padding: 2rem; margin-bottom: 2rem; }
        .getting-started { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: 8px; padding: 1.5rem; margin-bottom: 2rem; }
        .getting-started h3 { margin-bottom: 0.75rem; }
        .getting-started p { color: var(--color-text-muted); margin-bottom: 1rem; font-size: 0.9rem; }
        .code-block { display: block; background: #1a1a2e; color: #e0e0e0; padding: 1rem; border-radius: 4px; font-size: 0.8rem; white-space: pre-wrap; margin-top: 0.5rem; }
        .usage-info { margin-top: 2rem; }
        .usage-info h3 { margin-bottom: 1rem; }
        .plans { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; }
        .plan { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: 8px; padding: 1.25rem; }
        .plan h4 { margin-bottom: 0.75rem; color: var(--color-primary); }
        .plan ul { list-style: none; }
        .plan li { padding: 0.25rem 0; font-size: 0.9rem; color: var(--color-text-muted); }
        .plan li::before { content: "✓ "; color: #28a745; }
      `}</style>
    </div>
  );
}
